import { FILTERS_RESET } from '../../../../actions/filters';
import { SPONSORED_AGENT_LOADED } from '../../../../actions/sponsoredAgent';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';

export const sponsoredAgentReducer = (
  state: string | null = null,
  action: Action,
): string | null => {
  switch (action.type) {
    case SPONSORED_AGENT_LOADED:
      return action.payload.sponsoredAgent;
    case FILTERS_RESET:
      return null;
    default:
      return state;
  }
};
